import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_mb-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_option_field = _resolveComponent("option-field")
  const _component_text_area_field = _resolveComponent("text-area-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: _ctx.Resources.Comments.ReportAndHideCommentModalTitle,
    icon: "eye-slash",
    "is-processing": _ctx.isProcessing,
    "is-visible": true
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link gfu-link--accent _ttl",
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
      _createVNode(_component_base_button, {
        size: "default",
        width: "compact",
        "text-transform": "none",
        wide: true,
        bold: true,
        theme: "accent",
        enabled: !_ctx.isProcessing,
        onClick: $options.onReportAndHideProjectComment,
        "data-qa": "modal-button:Confirm"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalConfirmButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["enabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.Resources.Comments.ReportAndHideCommentModalParagraph), 1 /* TEXT */),
      _createVNode(_component_base_notificator, {
        type: "info",
        "can-close": false,
        class: "_mb-2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Comments.ReportAndHideCommentModalInformation), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_option_field, {
        modelValue: $data.model.reason,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.reason) = $event)),
        name: "model.reason",
        "display-name": _ctx.Resources.Comments.ReportCommentModalReasonFieldLabel,
        options: $options.availableReportReasons,
        "no-option-capitalize": true,
        "data-qa": "modal-select:Reason"
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "options"]),
      _createVNode(_component_text_area_field, {
        modelValue: $data.model.reasonDescription,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.reasonDescription) = $event)),
        name: "model.reasonDescription",
        "display-name": _ctx.Resources.Comments.ReportCommentModalReasonDescriptionFieldLabel,
        "data-qa": "modal-field:ReportReasonDescription"
      }, null, 8 /* PROPS */, ["modelValue", "display-name"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "is-processing"]))
}